import FFListController from 'FF/Controllers/Web/Shop/Product/ListController';

import ListController from 'Vue/Web/Shop/Product/ListController.vue';

global.Controller = new (class extends FFListController {
  ListControllerVue?: Vue;
  ready() {
    super.ready();

    /* 初始vue*/
    this.ListControllerVue = new Vue({
      ...ListController,
      el: '.productContent',
      propsData: {
        authCheck: Json.authCheck,
      },
    });
  }
})();
